import css from './GSTicketCard.module.scss'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { IGoodServiceTicketData, Tap2GOTicketTicketStatus } from 'meta/pages/goodsandservices'
import { Dates } from 'utils/dates'

import Img from 'components/Media/Img'

import NotValid from './Status/NotValid'
import Valid from './Status/Valid'
import Details from './Details'
import Header from './Header'
import DataTestId from 'meta/dataTestId'

interface Props {
  showTap2GoModal: (show: boolean) => void
  showQRCodeModal: (show: boolean) => void
  showFullDescriptionModal: (show: boolean) => void
  data: IGoodServiceTicketData
  insideSlider?: boolean
  insideWallet?: boolean
  totalSelectedTickets?: number
  handleMultipleSelection?: (remove?: boolean) => void
}

const GSTicketCard: React.FC<Props> = (props) => {
  const {
    showTap2GoModal,
    showQRCodeModal,
    showFullDescriptionModal,
    data,
    insideSlider,
    insideWallet,
    totalSelectedTickets,
    handleMultipleSelection,
  } = props

  const [showDetails, setShowDetails] = useState<boolean>(false)

  const { t } = useTranslation()

  const isEventEnded = Dates.isAfter(new Date(), new Date(data.validTo_tz))

  const ticketIconStatus = ![Tap2GOTicketTicketStatus.valid, Tap2GOTicketTicketStatus.checked].includes(
    data.status as Tap2GOTicketTicketStatus
  )
    ? 'error'
    : data.status

  const ticketIconPath = `${data?.event?.policy?.code}-icon-${ticketIconStatus}`

  const isTicketValid = data.status == Tap2GOTicketTicketStatus.valid && !isEventEnded && Boolean(data.secret)

  const [isTicketSelected, setIsTicketSelected] = useState<boolean>(false)

  useEffect(() => {
    handleMultipleSelection && handleMultipleSelection(!isTicketSelected)
  }, [isTicketSelected])

  useEffect(() => {
    if (isTicketSelected && data.status == Tap2GOTicketTicketStatus.checked) {
      setIsTicketSelected(false)
    }
  }, [data.status, isTicketSelected])

  return (
    <div
      className={classNames(
        css.wrapper,
        { [css.insideSlider]: insideSlider },
        { [css.isTicketSelected]: isTicketSelected }
      )}
    >
      {handleMultipleSelection && totalSelectedTickets !== undefined && totalSelectedTickets > 0 && isTicketValid && (
        <div
          className={css.selectedTicketOverlay}
          onClick={() => {
            setIsTicketSelected(!isTicketSelected)
          }}
        />
      )}

      {!showDetails && (
        <div className={classNames(css.ticketIcon)}>
          <Img src={`/goodsandservices/${ticketIconPath}.svg`} />
        </div>
      )}
      {isTicketSelected && !showDetails && <div className={css.borderOverlay} />}
      {isTicketSelected && !showDetails && (
        <div className={classNames(css.ticketIcon, { [css.isTicketSelected]: isTicketSelected })} />
      )}

      <button
        data-testid={DataTestId.bag.btnDetails}
        className={classNames(css.detailsIcon, { [css.goBack]: showDetails })}
        onClick={() => {
          setShowDetails(!showDetails)
        }}
      >
        {showDetails ? (
          <Img src="/goodsandservices/details-goback-rounded-big.svg" />
        ) : (
          <Img src="/icons/info_white.svg" />
        )}
      </button>

      {!showDetails && (
        <>
          <Header data={data} showFullDescriptionModal={showFullDescriptionModal} />

          {isTicketValid && handleMultipleSelection && (
            <div
              className={css.multipleSelection}
              onClick={() => {
                setIsTicketSelected(!isTicketSelected)
              }}
            >
              <div className={css.checkbox}>{isTicketSelected && <span>&#10003;</span>}</div>
              <span className={css.label}>{t('goodsAndServices:select')}</span>
            </div>
          )}

          {isTicketValid ? (
            <Valid
              data={data}
              showTap2GoModal={showTap2GoModal}
              isTicketSelected={isTicketSelected}
              totalSelectedTickets={totalSelectedTickets}
              insideWallet={insideWallet}
            />
          ) : (
            <NotValid data={data} showQRCodeModal={showQRCodeModal} />
          )}
        </>
      )}

      {showDetails && <Details data={data} />}
    </div>
  )
}

export default GSTicketCard
